import * as React from 'react';
import { Alert, Col, Container, Form, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { WebsiteEventsPage } from '../website-events/WebsiteEventsPage';
import { InstitutionView, InstitutionViewRow } from 'cb-model';
import { InstitutionCard } from '../institution/InstitutionCard';
import { PaginatorAndListSettings, useCacheQuery } from 'gossamer-front-end';
import { Filter, QueryOptions } from 'gossamer-unified';

const PAGE_SIZE = 15;

export interface ResultsProps {
  searchText: string;
}

export const WebsiteSearchPage = (): React.JSX.Element => {
  const [searchParams, _setSearchParams] = useSearchParams();
  const term = searchParams.get('searchTerm') || '';

  return (
    <Container fluid>
      <InstitutionResults searchText={term} />
      <div className="mb-3" />
      <WebsiteEventsPage
        emptyText="No matching events found."
        where={term ? { and: [{ fieldId: 'title', operator: 'ct', value: term }] } : undefined}
      />
    </Container>
  );
};

export const InstitutionResults = (props: ResultsProps) => {
  const searchFilterRef = React.useRef<Filter>({ fieldId: 'name', operator: 'ct', value: props.searchText });
  const [queryOptions, setQueryOptions] = React.useState<QueryOptions>({
    where: { and: [searchFilterRef.current] },
  });
  React.useEffect(() => {
    const newQueryOptions = { ...queryOptions };
    searchFilterRef.current.value = props.searchText;
    newQueryOptions.where = { and: [searchFilterRef.current] };
    setQueryOptions(newQueryOptions);
  }, [props.searchText]);
  const gCacheQueryItem = useCacheQuery(InstitutionView, queryOptions);
  return (
    <PaginatorAndListSettings
      entity={InstitutionView}
      gCacheQuery={gCacheQueryItem}
      queryOptions={queryOptions}
      render={() => <InstitutionResultsInner rows={gCacheQueryItem.data || []} />}
      setQueryOptions={setQueryOptions}
      showSettingsControl={false}
      showItemCount={false}
    />
  );
};

const InstitutionResultsInner = (props: { rows: InstitutionViewRow[] }) => {
  if (props.rows.length === 0) return <Alert variant="light">No matching institutions found</Alert>;
  return (
    <Row>
      {props.rows
        .filter((_row, index) => index < PAGE_SIZE)
        .map((row) => (
          <Col key={row.id} xs={12} md={6} lg={4} xl={3}>
            <InstitutionCard row={row} key={row.id} />
          </Col>
        ))}
    </Row>
  );
};
